import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { documentEngineTemplatesKeys } from '../documentEngineTemplatesKeys'
import {
  DocumentEngineTemplate,
  IDocumentEngineTemplate,
} from '@core/entities/document-engine'

const templatesTransform = (response: IDocumentEngineTemplate[]) =>
  response.map(DocumentEngineTemplate.new)

export const useGetDocumentEngineTemplates = (
  payload: RequestTypes['getDocumentEngineTemplates'],
  options?: UseQueryOptions<
    IDocumentEngineTemplate[],
    RequestErrorType,
    DocumentEngineTemplate[]
  >,
) => {
  return useQuery({
    select: templatesTransform,
    ...documentEngineTemplatesKeys.byOrganisation(payload),
    ...options,
  })
}
